import { Injectable } from '@angular/core';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, Observable, of, switchMap, tap } from 'rxjs';
import { MenuPanel, SideMenu } from './sidebar.types';
import { Bank } from '@page/connect-bank-account/helper/connect-bank-types';
import { ConnectBankService } from '@page/connect-bank-account/helper/connect-bank-account.service';
import { StorageService } from '@core/storage-module/storage.service';
import { UserService } from '@core/auth/user/user.service';
import { find } from 'lodash-es';
import { ApiService } from '@core/auth/auth.service';
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public _menuPanel: BehaviorSubject<MenuPanel | null> = new BehaviorSubject<MenuPanel | null>(null);
  bankId: any = '';
  set menuPanel(v: MenuPanel) {
    this._menuPanel.next(v);
  }

  get menuPanel(): MenuPanel {
    return this._menuPanel.getValue() as MenuPanel
  }

  get menuPanel$(): Observable<MenuPanel | null> {
    return this._menuPanel.asObservable();
  }

  getMenuItem(id: string): SideMenu | undefined {

    return find(this.menuPanel.sideMenu, { id }) as SideMenu | undefined;


  }

  constructor(
    private _ApiService: ApiService,
    private _ConnectBankService: ConnectBankService,
    private _StorageService: StorageService,
    private _UserService: UserService

  ) {
    if (this._StorageService.hasKey('menuPanel')) {
      this.menuPanel = this._StorageService.getItem('menuPanel');
    }
    if (this._StorageService.hasKey('bankId')) {
      this.bankId = this._StorageService.getItem('bankId');
    }
  }


  getMenu(bank_id: string = '', bankDtl?: Bank): Observable<any> {

    if (this.menuPanel && this.bankId == bank_id) {
      return of(this.menuPanel).pipe(tap(() => {
        this.menuPanel = this.menuPanel;
      }));
    }
    this.bankId = bank_id;
    const reqBody = {
      id: bank_id
    }
    return this._ApiService.post(config.sidemenu.live, reqBody).pipe(
      switchMap((r: any) => {
        if (r.code == 200) {
          if (bankDtl) {
            const fn = (url: string) => `/${bankDtl.name}/${url}`;
            (r.data as SideMenu[]).forEach((e: SideMenu) => {
              if (e.name == 'Home') {
                // e.title = 'Home'
              } else
                if (e.type == 'item') {
                  e.url = e.externalLink ? e.url : fn(e.url as string);
                  if (e.name === 'Reports') {
                    e.url = `/${bankDtl.name}/dynamic-report`;
                  }
                } else if (e.type === 'group') {
                  (e.children as SideMenu[]).forEach((d: SideMenu) => {
                    d.url = fn(d.url as string);
                  })
                }
            });
            this._ConnectBankService.isBankModuleActive = bankDtl.name;
          }
          if (this._UserService.loginData.is_ticket == 1) {
            (r.data as SideMenu[]) = [
              ...r.data,
              {
                "id": 4,
                "name": "Ticket",
                "type": "item",
                "menu": [
                  {
                    "id": 70,
                    "name": "Track My Complaint",
                    "url": "/managecomplaint/trackcomplaint",
                    "exact_match": 0,
                    "menu": "Track My Complaint",
                    "icon": "icon-track-complaint",
                    "menu_order": 6,
                    "parent_id": 4
                  }
                ],
                "icon": "icon-ticket",
                "menu_order": 3,
                "is_active": 1
              }
            ]
          }
          this.menuPanel = {
            label_image: r?.label_image ?? '',
            sideMenu: r.data,
            seamlesspermission: r.seamlesspermission
          }
          this._StorageService.setItem('menuPanel', this.menuPanel);

        } else {
          r = false;
        }
        return of(r);
      })
    );
  }
}
